import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
type Bono = {
  tag: string;
  title: string;
  paragraphs: string[];
  value: string;
  image?: string;
  alt?: string;
};
const BONOS: Bono[] = [{
  tag: 'Bono #1',
  title: '🆘 Guía de Rescate Clínico: Qué Hacer Cuando el Tratamiento No Avanza',
  paragraphs: ['Todo odontólogo vive ese momento en el que un caso parece estancarse.', 'La diferencia entre un profesional inseguro y uno con criterio no es que nunca tenga dificultades, sino que sabe exactamente cómo actuar cuando aparecen.', 'Con esta guía aprenderás a identificar por qué un tratamiento dejó de avanzar, cuándo realizar ajustes, cuándo cambiar de estrategia y cómo recuperar el rumbo sin improvisar.'],
  value: '$37 USD',
  image: 'https://cdn.magicpatterns.com/uploads/7MpbLpYt6Uz74BR4tYpb8i/BONO_1_DECISION.png',
  alt: 'Bono 1: Guía de Rescate Clínico en formato digital'
}, {
  tag: 'Bono #2',
  title: '🎥 Masterclass: Los 3 Errores que Sabotean el Crecimiento Mandibular',
  paragraphs: ['Muchas veces el problema no es el aparato. Es todo aquello que nadie evaluó antes.', 'Descubre los tres factores que más frecuentemente bloquean el crecimiento mandibular y aprende a detectarlos antes de iniciar cualquier tratamiento funcional.', 'Desarrollarás un criterio clínico que normalmente solo se obtiene después de años de experiencia.'],
  value: '$47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/ckFaKhfJ4w7iGSGTVGkGYd/BONO_2_DECISION.png',
  alt: 'Bono 2: Masterclass sobre los 3 errores que sabotean el crecimiento mandibular'
}, {
  tag: 'Bono #3',
  title: '🔧 Guía Definitiva para Solicitar el Aparato Perfecto al Laboratorio',
  paragraphs: ['Elegir correctamente el aparato es solo la mitad del trabajo. Si el laboratorio recibe una indicación incompleta, el tratamiento comienza con errores desde el primer día.', 'Aprende exactamente qué información debe incluir cada orden para reducir ajustes, evitar retrasos y recibir un aparato correctamente confeccionado desde la primera entrega.'],
  value: '$25 USD',
  image: 'https://cdn.magicpatterns.com/uploads/bAWfTiJXphn8ETyFYze3nQ/BONO_3_DECISION.png',
  alt: 'Bono 3: Guía definitiva para solicitar el aparato perfecto al laboratorio'
}, {
  tag: 'Bono #4',
  title: '📄 Plantillas Profesionales de Consentimiento Informado',
  paragraphs: ['Explica cada tratamiento con claridad, protege tu práctica y transmite una imagen mucho más profesional.', 'Recibirás documentos listos para utilizar que ayudan a establecer expectativas claras, generar confianza en los padres y respaldar cada decisión clínica.'],
  value: '$19 USD',
  image: 'https://cdn.magicpatterns.com/uploads/phHrzhArEUaNw5Wjw18BQZ/BONO_4_DECISION.png',
  alt: 'Bono 4: Plantillas profesionales de consentimiento informado'
}, {
  tag: 'Bono #5',
  title: '💰 Calculadora de Rentabilidad Clínica',
  paragraphs: ['Muchos odontólogos realizan excelentes tratamientos… pero siguen cobrando mal.', 'Con esta herramienta podrás calcular cuánto debería costar cada tratamiento funcional considerando tiempo clínico, laboratorio y rentabilidad real.', 'Porque un buen criterio clínico también debe traducirse en una consulta más rentable.'],
  value: '$27 USD',
  image: 'https://cdn.magicpatterns.com/uploads/4eKeAK2fBd3R1Vu36f7w8f/BONO_5_DECISION.png',
  alt: 'Bono 5: Calculadora de Rentabilidad Clínica para tratamientos funcionales'
}];
export function Bonos() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-51" data-mp="a7yhhgb3y7dr">
      <div className="mx-auto w-full max-w-3xl" data-id="element-52" data-mp="57kkqueyijv1">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-53" data-mp="k41slbnxtgcu">
          Además, recibirás estos 5 bonos exclusivos totalmente{' '}
          <span className="text-ofm-600" data-id="element-54" data-mp="28nxl4fmrd2jz">GRATIS</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ofm-900/70 sm:text-lg" data-id="element-55" data-mp="28neazl3cnigi">
          Herramientas creadas para que apliques el Sistema OFM con mayor seguridad
          desde el primer día.
        </p>

        <div className="mt-9 space-y-5" data-id="element-56" data-mp="2nckazba0hcpg">
          {BONOS.map((bono, i) => <motion.article key={bono.tag} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className="overflow-hidden rounded-2xl border border-ofm-100 bg-white shadow-sm" data-id="element-57" data-mp="2neocxnoco1n3" data-mpi={i}>
              {bono.image && <div className="flex items-center justify-center bg-ofm-50 p-4 sm:p-6" data-id="element-58" data-mp="3b2entsubz19p">
                  <img src={bono.image} alt={bono.alt ?? bono.title} className="block h-auto w-full max-w-[420px] object-contain" loading="lazy" data-id="element-59" data-mp="3b4r0prl8elfw" />
                </div>}
              <div className="p-5 sm:p-6" data-id="element-60" data-mp="zful5s7ykkta">
                <span className="inline-block rounded-full bg-gold/15 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-[#8A6420]" data-id="element-61" data-mp="unt2nok75xut">
                  {bono.tag}
                </span>
                <h3 className="mt-3 font-display text-[19px] font-bold leading-snug text-ofm-900 sm:text-2xl" data-id="element-62" data-mp="kqoexkapdubw">
                  {bono.title}
                </h3>
                {bono.paragraphs.map(p => <p key={p} className="mt-2.5 text-[14px] leading-relaxed text-ofm-900/70 sm:text-[15px]" data-id="element-63" data-mp="booyat3los9h">
                    {p}
                  </p>)}
                <p className="mt-4 text-[13px] font-extrabold uppercase tracking-wide text-ofm-700" data-id="element-64" data-mp="262znj2o3xofs">
                  Valor: <span className="line-through opacity-60" data-id="element-65" data-mp="2157wsbz788d6">{bono.value}</span>{' '}
                  <span className="text-ofm-600" data-id="element-66" data-mp="3vj27yfw50cyc">hoy gratis</span>
                </p>
              </div>
            </motion.article>)}
        </div>

        <CTAButton className="mt-9" label="🦷 QUIERO EL SISTEMA + LOS 5 BONOS" subline="$155 USD en bonos incluidos sin costo adicional" data-id="element-67" data-mp="3lmz5f8xdicav" />
      </div>
    </section>;
}